import(/* webpackMode: "eager" */ "/vercel/path0/examples/next/src/app/page.tsx");
